module.exports = __webpack_public_path__ + "logo_notext.png?2974dbeade66a6476cf8c5c82e5665e0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_notext.png
// module id = 322
// module chunks = 0